import { PlusIcon } from "@heroicons/react/24/outline";
import { DocumentTextIcon } from "@heroicons/react/24/outline";
import TemplateLists from "components/templates/TemplateLists";
import { useLanguage } from "contexts/LanguageContext";
import { useState } from "react";
import { useAuth } from "contexts/AuthContext";
import CommonPageHeader from "../components/common/CommonPageHeader";

const Templates = () => {
  const { t } = useLanguage();
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  const { user } = useAuth();

  return (
    <div className="space-y-4">
      <CommonPageHeader
        title={t("templates.title")}
        subtitle="Szerződés sablonok kezelése és áttekintése"
        icon={DocumentTextIcon}
      >
        {user?.role !== 'user' && (
          <button
            onClick={() => setIsCreateModalOpen(true)}
            className="bg-white/20 backdrop-blur-sm text-white px-3 py-2 rounded-md text-sm flex items-center justify-center hover:bg-white/30 transition-colors"
          >
            <PlusIcon className="h-4 w-4 mr-2" />
            <span>{t("templates.newTemplate")}</span>
          </button>
        )}
      </CommonPageHeader>

      {/* Szerződések listája */}
      <TemplateLists
        isCreateModalOpen={isCreateModalOpen}
        setIsCreateModalOpen={setIsCreateModalOpen}
      />
    </div>
  );
}

export default Templates;